import React, { useState, useEffect } from "react";
import { alertsActions, reservationsActions, locationActions, useSelector } from "inbooma-api";
import { Biscuit, FormatHelper, Notification } from "../../../../utils";
import t from "../../../helpers/t";
import { getContentModifications } from "../../../../App";
import { _, moment, $, Dropdown, DropdownButton } from "../../../../../vendor";

const ResourceListView = (props) => {
  return <>test</>;
};

export default ResourceListView;
